export default __webpack_public_path__ + "static/media/balance-wellness-types-blocks.68531564.md";